import { send } from "@utils/fetch";

export function getReferralCode() {
  return send("GET", `/api/referrals/v1/user_referral_code`);
}
